import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>
        import(/* webpackChunkName: "home" */ './views/Home.vue'),
    },
    {
      path: '/planification',
      name: 'planification',
      component: () =>
        import(
          /* webpackChunkName: "planification" */ './views/Planification.vue'
        ),
    },
    {
      path: '/directories/:id?',
      name: 'directories',
      component: () =>
        import(/* webpackChunkName: "directory" */ './views/Directories.vue'),
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () =>
        import(/* webpackChunkName: "contacts" */ './views/Contacts.vue'),
    },
    {
      path: '/courseConnection',
      name: 'courseConnection',
      component: () =>
        import(
          /* webpackChunkName: "courseConnection" */ './views/CourseConnection.vue'
        ),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.query.code && !store.state.auth.credentials.access_token) {
    store.dispatch('auth/login', to.query.code);
    next();
  } else if (!store.state.auth.credentials.access_token) {
    store.dispatch('auth/getAuthorizationCodeAndRedirect');
  } else {
    next();
  }
});

export default router;
